export default __webpack_public_path__ + "static/media/SomethingWrong.f143a1cc.svg";